import { globalState } from "@/state";
import { ElMessageBox, ElMessage } from "element-plus";
import { requireLogin } from "@/utils/authGuard";
import {
  getDownloadCost,
  getPointConfig,
  isDownloadEnabled,
} from "@/utils/pointConfig";
import { getDownloadFree, isToolFree } from "@/utils/downloadRule";
export default {
  name: "HomePage",
  data() {
    return {
      toolList: [],
      categoryList: [],

      currentFilter: "lastest",
      rankType: "download",
      rankDownloadList: [],
      rankRateList: [],
      subList: [],
      requestList: [],
      bannerList: [],
      currentBannerIndex: 0,
      bannerTimer: null,
      promptList: [],
      // 首页 AI 智能体板块（后台「首页设计」的 agents 板块控制显隐/标题/排序）
      agentList: [],
      // 首页软件分享板块（后台「首页设计」的 software 板块控制显隐/标题/排序）
      softwareList: [],
      promptDialogVisible: false,
      currentPrompt: null,
      promptCopied: false,
      askKeyword: "",
      // 首页板块配置（管理端「首页设计」维护：显隐/标题/副标题/排序）
      sections: [],
      // 我的应用：首页各板块卡片的「＋」状态（按类型存已加入 id）
      myAppMap: { tool: [], agent: [], prompt: [], request: [], software: [] },
      myAppBusy: "",
    };
  },
  computed: {
    topDownloadedTools() {
      return [...this.rankDownloadList].slice(0, 3);
    },
    currentBanner() {
      return this.bannerList[this.currentBannerIndex] || null;
    },
    topRatedTools() {
      return [...this.rankRateList].slice(0, 3);
    },
    user() {
      return this.$store.state.user;
    },
    isLogin() {
      return this.user && this.user.uid;
    },
    // 下载/在线使用消耗创值（后台可配置）
    downloadCost() {
      return getPointConfig().downloadCost;
    },
    // 当前用户是否属于免创值群体（义乌教师）
    downloadFree() {
      return getDownloadFree();
    },
    // 平台是否开放下载（后台总开关）
    downloadEnabled() {
      return isDownloadEnabled();
    },
  },
  created() {
    this.getCategory();
    this.getRequestList();
    this.getBanners();
    this.getPromptList();
    this.getAgents();
    this.getSoftwares();
    this.getSections();
    // 首页卡片「＋」状态（工具卡片沿用 isFav，不需要单独拉）
    ["agent", "prompt", "request", "software"].forEach((t) =>
      this.loadMyAppIds(t),
    );
  },
  beforeUnmount() {
    this.stopBannerTimer();
  },
  methods: {
    // ========== 我的应用（首页卡片「＋」） ==========
    async loadMyAppIds(type) {
      if (!localStorage.getItem("token")) return;
      try {
        const res = await this.$axios({ url: `fav/ids/${type}` });
        if (res.code === 200 && Array.isArray(res.data)) {
          this.myAppMap = { ...this.myAppMap, [type]: res.data };
        }
      } catch (e) {
        /* 未登录/网络异常时静默 */
      }
    },
    inMyApps(type, id) {
      return (this.myAppMap[type] || []).indexOf(id) >= 0;
    },
    /** 首页卡片：加入 / 移出我的应用 */
    toggleMyApp(type, id) {
      if (!requireLogin(this, "加入我的应用")) return;
      if (!id || this.myAppBusy) return;
      const added = this.inMyApps(type, id);
      this.myAppBusy = id;
      this.$axios({
        url: `fav/${type}/${id}`,
        method: added ? "DELETE" : "GET",
      })
        .then((res) => {
          if (res.code !== 200) {
            ElMessage.error(res.msg || "操作失败");
            return;
          }
          const list = this.myAppMap[type] || [];
          this.myAppMap = {
            ...this.myAppMap,
            [type]: added ? list.filter((x) => x !== id) : [...list, id],
          };
          ElMessage.success(added ? "已从我的应用移出" : "已加入我的应用");
        })
        .catch(() => ElMessage.error("操作失败，请稍后重试"))
        .finally(() => {
          this.myAppBusy = "";
        });
    },

    // ========== 首页板块配置（管理端「首页设计」维护） ==========
    getSections() {
      this.$axios({ url: "home/sections" })
        .then((res) => {
          if (res.code === 200) {
            this.sections = res.data || [];
          }
        })
        .catch(() => {});
    },
    sectionOf(key) {
      return this.sections.find((s) => s.sectionKey === key) || null;
    },
    // 未配置到该板块时默认显示，保证后台没配置也不影响首页
    showSection(key) {
      const s = this.sectionOf(key);
      return s ? s.status === 1 : true;
    },
    sectionTitle(key, def) {
      const s = this.sectionOf(key);
      return s && s.title ? s.title : def;
    },
    sectionSubtitle(key, def) {
      const s = this.sectionOf(key);
      return s && s.subtitle ? s.subtitle : def;
    },
    // 用 flex order 控制顺序，无需重排 DOM
    // 未配置的板块兜底为 999（排最后），避免 order 默认 0 抢占最前面
    sectionStyle(key) {
      const s = this.sectionOf(key);
      return { order: s ? s.sortNum || 0 : 999 };
    },

    // 首页轮播图
    getBanners() {
      this.$axios({
        url: "banner/list",
      }).then((res) => {
        if (res.code === 200) {
          this.bannerList = res.data || [];
          if (this.bannerList.length > 1) {
            this.startBannerTimer();
          }
        }
      }).catch(() => {});
    },
    startBannerTimer() {
      this.stopBannerTimer();
      if (this.bannerList.length < 2) return;
      this.bannerTimer = setInterval(() => {
        this.currentBannerIndex =
          (this.currentBannerIndex + 1) % this.bannerList.length;
      }, 4000);
    },
    stopBannerTimer() {
      if (this.bannerTimer) {
        clearInterval(this.bannerTimer);
        this.bannerTimer = null;
      }
    },
    nextBanner() {
      this.currentBannerIndex =
        (this.currentBannerIndex + 1) % this.bannerList.length;
    },
    prevBanner() {
      this.currentBannerIndex =
        (this.currentBannerIndex - 1 + this.bannerList.length) %
        this.bannerList.length;
    },
    gotoBanner(i) {
      this.currentBannerIndex = i;
    },

    checkLogin(router) {
      if (!this.isLogin) {
        requireLogin(this, "该功能");
        return;
      }

      this.$axios({
        url: "aitool/user/checklogin",
      }).then((res) => {
        if (res.code == 200) {
          this.$router.push(router);
        }
      });
    },
    // 某个工具是否免创值（义乌教师 或 自己的作品）
    toolIsFree(tool) {
      return isToolFree(tool, this.user && this.user.uid);
    },
    downloadAction(tool) {
      if (!requireLogin(this, "下载文件")) return;
      if (!isDownloadEnabled()) {
        ElMessage({
          message: "平台已关闭下载权限，暂无法下载或在线使用",
          type: "warning",
        });
        return;
      }

      const confirmText = this.toolIsFree(tool)
        ? `确认免费下载工具《${tool.title}》`
        : `确认消耗：${getDownloadCost()}创值下载工具《${tool.title}》`;

      ElMessageBox.confirm(
        confirmText,
        "下载工具",
        {
          confirmButtonText: "下载",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          // 发起下载请求
          this.$axios({
            url: "aitool/download/" + tool.id, // 注意：这里建议检查URL拼接是否正确，通常需要 / 分隔，比如 "aitool/download/" + tool.id
          })
            .then(async (res) => {
              if (res.code == 200) {
                const fileUrl = res.data.file;
                // 调用下载函数
                this.downloadFile(fileUrl, tool.title);

                // 提示下载成功
                ElMessage({
                  message: "下载已开始",
                  type: "success",
                });
              } else {
                ElMessage({
                  message: res.msg || "下载失败", // 注意：你原代码是 res.msh，应该是笔误，修正为 res.msg
                  type: "error",
                });
              }
            })
            .catch((err) => {
              // 捕获请求异常
              ElMessage({
                message: "网络错误，下载失败",
                type: "error",
              });
              console.error("下载请求失败：", err);
            });
        })
        .catch(() => {
          // 用户取消下载的提示（可选）
          ElMessage({
            message: "已取消下载",
            type: "info",
          });
        });
    },

    // 封装文件下载函数
    downloadFile(fileUrl, fileName) {
      // 创建a标签
      const link = document.createElement("a");
      // 设置下载地址
      link.href = fileUrl;
      // 设置下载文件名（可选，若无则使用服务器返回的文件名）
      if (fileName) {
        link.download = fileName;
      }
      // 隐藏a标签
      link.style.display = "none";
      // 添加到DOM
      document.body.appendChild(link);
      // 触发点击
      link.click();
      // 移除a标签
      document.body.removeChild(link);
    },
    getCategory() {
      this.$axios({
        url: "subinfo/list",
      }).then((res) => {
        this.subList = res.data;
      });
      this.$axios({
        url: "category/list/count",
      }).then(async (res) => {
        this.categoryList = res.data;
        this.getToolsList(this.currentFilter);
        await this.getRankDownload();
      });
    },
    async getRankDownload() {
      var data = await this.$aesEncrypt({
        timeType: "all",
        category: "all",
      });
      var uid = "";
      if (this.isLogin) {
        uid = this.user.uid;
      }
      this.$axios({
        url: "aitool/rank/month/download?uid=" + uid,
        method: "POST",
        data: {
          data: data,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.rankDownloadList = res.data;
        }
      });

      this.$axios({
        url: "aitool/rank/month/rating?uid=" + uid,
        method: "POST",
        data: {
          data: data,
        },
      }).then((res) => {
        if (res.code == 200) {
          this.rankRateList = res.data;
        }
      });
    },

    getToolsList(type) {
      this.currentFilter = type;
      var uid = "";
      if (this.isLogin) {
        uid = this.user.uid;
      }
      this.$axios({
        url: `aitool/list/home/${type}?uid=${uid}`,
      }).then((res) => {
        this.toolList = res.data;
      });
    },
    openToolDetail(tool) {
      globalState.openModal(tool.id, this.categoryList);
    },
    openRequestDetail(request) {
      globalState.openRequestModal(request.id, this.categoryList);
    },
    getCategoryName(id) {
      const category = this.categoryList.find((c) => c.id === id);
      return category ? category.title : "未知";
    },

    getSubName(id) {
      var sub = this.subList.find((c) => c.id === id);
      return sub ? sub.title : "";
    },
    formatNumber(num) {
      if (num >= 1000) {
        return (num / 1000).toFixed(1) + "k";
      }
      return num;
    },
    getRequestList() {
      this.$axios({
        url: "demand/newest",
        method: "GET"
      }).then((res) => {
        if (res.code === 200) {
          this.requestList = res.data || [];
        }
      }).catch((err) => {
        console.error("获取需求列表失败:", err);
        this.requestList = [];
      });
    },

    // 首页 AI 智能体：取启用中的前 8 个，避免首页过长
    getAgents() {
      this.$axios({ url: "agent/list" })
        .then((res) => {
          if (res.code === 200) {
            this.agentList = (res.data || []).slice(0, 8);
          }
        })
        .catch(() => {});
    },
    // 进入智能体对话
    goAgentChat(agent) {
      this.$router.push("/agent/" + agent.id);
    },
    // 首页软件分享：取前 4 个
    getSoftwares() {
      this.$axios({ url: "software/list", method: "GET" })
        .then((res) => {
          if (res.code === 200) {
            this.softwareList = (res.data || []).slice(0, 4);
          }
        })
        .catch(() => {});
    },
    goSoftware() {
      this.$router.push("/software");
    },
    agentFirstChar(name) {
      return name ? name.trim().charAt(0) : "A";
    },

    // 热门提示词 / 技巧分享（按点赞+浏览排序）
    async getPromptList() {
      try {
        const data = await this.$aesEncrypt({
          page: 1,
          pageSize: 6,
          sort: "hot",
        });
        const res = await this.$axios({
          url: "prompt/list",
          method: "POST",
          data: { data },
        });
        if (res.code === 200) {
          this.promptList = res.data.list || [];
        }
      } catch (e) {
        console.error("获取提示词列表失败:", e);
      }
    },
    // 打开“小义问宝”AI 问答
    openAskBot() {
      const q = (this.askKeyword || "").trim();
      globalState.openAskBot(q);
      this.askKeyword = "";
    },
    getPromptTypeText(type) {
      return type === "skill" ? "技巧分享" : "提示词";
    },
    openPrompt(item) {
      this.currentPrompt = item;
      this.promptCopied = false;
      this.promptDialogVisible = true;
      // 拉取详情（登录用户附带点赞/收藏状态）
      this.$axios({ url: "prompt/detail/" + item.id })
        .then((res) => {
          if (res.code === 200 && res.data && res.data.info) {
            this.currentPrompt = res.data.info;
          }
        })
        .catch(() => {});
    },
    // 提示词点赞 / 取消点赞
    promptLikeAction() {
      const item = this.currentPrompt;
      if (!item) return;
      if (!requireLogin(this, "点赞")) return;
      const unZan = !!item.isZan;
      item.isZan = !unZan;
      item.likeCount = (item.likeCount || 0) + (unZan ? -1 : 1);
      this.$axios({
        url: "prompt/like/" + item.id,
        method: unZan ? "DELETE" : "GET",
      })
        .then((res) => {
          if (res.code === 200 && res.data && res.data.likeCount !== undefined) {
            item.likeCount = res.data.likeCount;
          } else {
            ElMessage.error(res.msg || "操作失败");
            item.isZan = unZan;
            item.likeCount = (item.likeCount || 0) + (unZan ? 1 : -1);
          }
        })
        .catch(() => {
          ElMessage.error("操作失败，请稍后重试");
          item.isZan = unZan;
          item.likeCount = (item.likeCount || 0) + (unZan ? 1 : -1);
        });
    },
    // 提示词收藏 / 取消收藏
    promptFavAction() {
      const item = this.currentPrompt;
      if (!item) return;
      if (!requireLogin(this, "收藏内容")) return;
      const unFav = !!item.isFav;
      item.isFav = !unFav;
      item.favCount = (item.favCount || 0) + (unFav ? -1 : 1);
      this.$axios({
        url: "prompt/fav/" + item.id,
        method: unFav ? "DELETE" : "GET",
      })
        .then((res) => {
          if (res.code === 200 && res.data && res.data.favCount !== undefined) {
            item.favCount = res.data.favCount;
            ElMessage.success(unFav ? "已取消收藏" : "收藏成功");
          } else {
            ElMessage.error(res.msg || "操作失败");
            item.isFav = unFav;
            item.favCount = (item.favCount || 0) + (unFav ? 1 : -1);
          }
        })
        .catch(() => {
          ElMessage.error("操作失败，请稍后重试");
          item.isFav = unFav;
          item.favCount = (item.favCount || 0) + (unFav ? 1 : -1);
        });
    },
    copyPrompt() {
      if (!this.currentPrompt) return;
      const text = this.currentPrompt.content || "";
      const done = () => {
        this.promptCopied = true;
        ElMessage.success("已复制到剪贴板");
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(() => {
          this.fallbackCopy(text, done);
        });
      } else {
        this.fallbackCopy(text, done);
      }
    },
    fallbackCopy(text, done) {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.display = "none";
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
        done();
      } catch (e) {
        ElMessage.error("复制失败，请手动选择复制");
      }
      document.body.removeChild(ta);
    },
    favAction(tool) {
      if (!requireLogin(this, "收藏工具")) return;
      if (tool.isFav) {
        tool.isFav = false;
        //取消
        this.$axios({
          url: "aitool/action/fav/" + tool.id,
          method: "DELETE",
        }).then((res) => {
          if (res.code != 200) {
            ElMessage.error(res.msg);
          }
        });
      } else {
        tool.isFav = true;
        this.$axios({
          url: "aitool/action/fav/" + tool.id,
        }).then((res) => {
          if (res.code != 200) {
            ElMessage.error(res.msg);
          }
        });
      }
    },

    zanAction(tool) {
      if (!requireLogin(this, "点赞工具")) return;
      if (tool.isZan) {
        tool.isZan = false;
        //取消
        this.$axios({
          url: "aitool/action/zan/" + tool.id,
          method: "DELETE",
        }).then((res) => {
          if (res.code != 200) {
            ElMessage.error(res.msg);
          }
        });
      } else {
        tool.isZan = true;
        this.$axios({
          url: "aitool/action/zan/" + tool.id,
        }).then((res) => {
          if (res.code != 200) {
            ElMessage.error(res.msg);
          }
        });
      }
    },
  },
};
